import type { BrowserAiToolsFilterableField } from '@kirin/api-client/contracts/shadow-ai-browser-tools';
import { BROWSER_AI_TOOLS_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/shadow-ai-browser-tools';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

export const BROWSER_AI_TOOLS_FILTER_URL_KEYS = {
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.DOMAIN]: 'dom',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.NAME]: 'n',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.CATEGORY]: 'cat',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.TREND]: 'tr',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.USERS]: 'uc',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.FIRST_DETECTED]: 'fd',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.LAST_SEEN]: 'ls',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.LOGGED_IN_USER]: 'liu',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.ENDPOINT]: 'ep',
} as const satisfies Record<BrowserAiToolsFilterableField, string>;

export const BROWSER_AI_TOOLS_TABLE_CONFIG = {
  tableId: TABLE_IDS.ORGANIZATION.SHADOW_AI.BROWSER,
} as const;
